import { HeroCustomizer } from "../HeroCustomizer";
import type { HeroOverrides } from "@profolio/templates/types";

interface HeroSubViewProps {
  hero: HeroOverrides;
  userTier?: string;
  currentThemeKey?: string | null;
  styleRecipe?: string | null;
  currentPhotoUrl?: string | null;
  fullName?: string;
  onPhotoUpdate?: (newPhotoUrl: string) => void;
  onFullNameUpdate?: (newFullName: string) => void;
  onUpdate: <K extends keyof HeroOverrides>(key: K, value: HeroOverrides[K]) => void;
  onUpgradeClick: (featureKey?: string) => void;
}

export function HeroSubView({
  hero,
  userTier,
  currentThemeKey,
  styleRecipe,
  currentPhotoUrl,
  fullName,
  onPhotoUpdate,
  onFullNameUpdate,
  onUpdate,
  onUpgradeClick,
}: HeroSubViewProps) {
  return (
    <div className="space-y-6 pb-12">
      <div className="border-b border-border pb-3">
        <h3 className="text-base font-bold text-foreground">Hero Section Presentation</h3>
        <p className="text-xs text-muted-foreground mt-0.5">
          Customize the layout, portrait avatar, headline alignment, and banner backgrounds of your profile hero.
        </p>
      </div>

      <HeroCustomizer
        hero={hero}
        userTier={userTier}
        currentThemeKey={currentThemeKey}
        styleRecipe={styleRecipe}
        currentPhotoUrl={currentPhotoUrl}
        fullName={fullName}
        onPhotoUpdate={onPhotoUpdate}
        onFullNameUpdate={onFullNameUpdate}
        onUpdate={onUpdate}
        onUpgradeClick={onUpgradeClick}
      />
    </div>
  );
}
